import React from "react";
import { Grid } from "@mui/material";
import { useAreas } from '../../hooks/useAreas';
import { useGetRoles } from "../../hooks/useGetRoles";
import { useSedes } from "../../hooks/useSedes";
import { Controller, useForm } from 'react-hook-form';
import { CustomInputSwitch } from "../CustomInputSwitch";
import { CustomInputSelect } from "../CustomInputSelect";
import { CustomInputText } from "../CustomInputText";
import { CustomButtonsForm } from "../CustomButtonsForm";

export const CreateUserForm = ({ action }) => {

    const { sedes } = useSedes();
    const { roles } = useGetRoles();
    const { areas } = useAreas();

   const { handleSubmit, control, formState: { errors } } = useForm();

    return (
        <form style={{ margin: '30px 30px 20px 30px', position: 'relative',  width: 420 }} onSubmit={handleSubmit(action)}>
            <Grid container>
                <Grid item xs={12}>
                    <Controller
                        name="nombre"
                        control={control}
                        defaultValue=""
                        render={({ field: { onChange, value } }) => (
                            <CustomInputText 
                                label='Nombres y Apellidos'
                                onChange={ onChange }
                                value={ value }
                                error={ errors.nombre }
                            />
                        )}
                        rules={{
                            required: "* Nombres y apellidos requeridos.",
                            pattern: {
                                value: /^[^\d^\s][a-zA-Z ]+[^\d^\s]$/,
                                message: "* Nombres y apellidos incorrectos.",
                            },
                        }}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Controller
                        name="correo"
                        control={control}
                        defaultValue=""
                        render={({ field: { onChange, value } }) => (
                            <CustomInputText
                                label='Correo electrónico'
                                onChange={ onChange }
                                value={ value }
                                error={ errors.correo }
                            />
                        )}
                        rules={{
                            required: "* Correo requerido.",
                            pattern: {
                                value: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                message: "* Correo electrónico incorrecto.",
                            },
                        }}
                    />
                </Grid>

                <Grid container spacing={2}>
                    <Grid item xs={12} lg={6}>
                        <Controller
                            name="sede"
                            control={control}
                            defaultValue=""
                            render={({ field: { onChange, value } }) => (
                                <CustomInputSelect
                                    label='Sede'
                                    options={sedes.map(a => ({ ...a, name: a?.nombre }))}
                                    onChange={ onChange }
                                    value={ value }
                                    error={ errors.sede }
                                />
                            )}
                            rules={{
                                required: "* Sede requerida.",
                            }}
                        />
                    </Grid>

                    <Grid item xs={12} lg={6}>
                        <Controller
                            name="rol"
                            control={control}
                            defaultValue=""
                            render={({ field: { onChange, value } }) => (
                                <CustomInputSelect
                                    label='Rol'
                                    options={roles.map(a => ({ ...a, name: a?.nombre }))}
                                    onChange={ onChange }
                                    value={ value }
                                    error={ errors.rol }
                                />
                            )}
                            rules={{
                                required: "* Rol requerido.",
                            }}
                        />
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <Controller
                        name="area"
                        control={control}
                        defaultValue=""
                        render={({ field: { onChange, value } }) => (
                            <CustomInputSelect
                                label='Area'
                                options={areas.map(a => ({ ...a, name: a?.nombre }))}
                                onChange={ onChange }
                                value={ value }
                                error={ errors.area }
                            />
                        )}
                        rules={{
                            required: "* Area requerida.",
                        }}
                    />
                </Grid>
                
                <Grid container spacing={2}>
                    <Grid item xs={12} lg={6}>
                        <Controller
                            name="username"
                            control={control}
                            defaultValue=""
                            render={({ field: { onChange, value } }) => (
                                <CustomInputText 
                                    label='Usuario'
                                    onChange={ onChange }
                                    value={ value }
                                    error={ errors.username }
                                />
                            )}
                            rules={{
                                required: "* Usuario requerido.",
                                pattern: {
                                    value: /^[^\d^\s][a-zA-Z ]+[^\d^\s]$/,
                                    message: "* Usuario incorrecto",
                                },
                            }}
                        />
                    </Grid>

                    <Grid item xs={12} lg={6}>
                        <Controller
                            name="contrasena"
                            control={control}
                            defaultValue=""
                            render={({ field: { onChange, value } }) => (
                                <CustomInputText 
                                    label='Contraseña'
                                    onChange={ onChange }
                                    value={ value }
                                    placeholder='******'
                                    error={ errors.contrasena }
                                />
                            )}
                            rules={{
                                required: "* Contraseña requerida.",
                                pattern: {
                                    value: /^[^\s]+[^\s]$/,
                                    message: "* Contraseña incorrecta",
                                },
                            }}
                        />
                    </Grid> 
                </Grid>

                {/* <Grid item xs={12}>
                    <Controller
                        name="autoriza_salida"
                        control={control}
                        defaultValue={false}
                        render={({ field: { onChange, value } }) => (
                            <CustomInputSwitch
                                label='¿Autoriza salida de activos?'
                                onChange={ onChange }
                                value={ value }
                            />
                        )}
                    />
                </Grid> */}
            </Grid>
            
            <CustomButtonsForm name='Guardar' style={{ position: 'sticky', bottom: 20 }} />
            {/* <CustomButtonsForm name='Actualizar' /> */}
        </form>
    );
}